export enum UserFirstLoginProviderEnum {
  EMAIL = 'EMAIL',
  FACEBOOK = 'FACEBOOK',
  APPLE = 'APPLE',
  GOOGLE = 'GOOGLE',
  NAIIN = 'NAIIN',
  LINE = 'LINE',
}
